import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/store/modules/auth.js";
import * as roles from "@/store/modules/roles.js";
import * as users from "@/store/modules/users.js";
import * as logs from "@/store/modules/logs.js";
import * as distritos from "@/store/modules/distritos.js";
import * as partidos from "@/store/modules/partidos.js";
import * as oficios from "@/store/modules/oficios.js";
import * as contestacion from "@/store/modules/contestacion.js";
import * as expedientes from "@/store/modules/expedientes.js";
import * as salas from "@/store/modules/salas.js";
import * as firma from "@/store/modules/firma.js";
import * as tocas from "@/store/modules/tocas.js";
import * as buzon from "@/store/modules/buzon.js";
import * as sentencias from "@/store/modules/sentencias.js";
import * as amparos from "@/store/modules/amparos.js";
import * as ponencias from "@/store/modules/ponencias.js";
import * as catCategorias from "@/store/modules/catCategorias.js";
import * as catDelitos from "@/store/modules/catDelitos.js";
import * as catMaterias from "@/store/modules/catMaterias.js";
import * as catMunicipios from "@/store/modules/catMunicipios.js";
import * as catJuzgados from "@/store/modules/catJuzgados.js";
import * as catTipoApelacion from "@/store/modules/catTipoApelacion.js"; //tipo de apelacion
import * as catVias from "@/store/modules/catVias.js";
import * as catPonencias from "@/store/modules/catPonencias.js";
import * as catSentidos from "@/store/modules/catSentidos.js";
import * as catTribunales from "@/store/modules/catTribunales.js";
import * as apelaciones from "@/store/modules/apelaciones.js";
import * as cuentas from "@/store/modules/cuentas.js";
import * as magistrados from "@/store/modules/magistrados.js";
import * as colegiadas from "@/store/modules/colegiadas.js";
import * as documentos from "@/store/modules/documentos.js";
import * as catTipoDocumentos from "@/store/modules/catTipoDocumentos.js";
import * as aElectronica from "@/store/modules/aElectronica.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    roles,
    users,
    logs,
    distritos,
    partidos,
    oficios,
    contestacion,
    expedientes,
    salas,
    firma,
    tocas,
    //buzon,
    sentencias,
    //amparos,
    ponencias,
    catCategorias,
    catDelitos,
    catMaterias,
    catMunicipios,
    catJuzgados,
    catTipoApelacion,
    catVias,
    catSentidos,
    catTribunales,
    apelaciones,
    cuentas,
    magistrados,
    colegiadas,
    documentos,
    catTipoDocumentos,
    aElectronica

    // catPonencias
  },
  state: {
    layout: "dashboard-layout",
    loading: false,
    notification: "",
    navigation_options: null
  },
  mutations: {
    SET_NOTIFICATION(state, payload) {
      // payload = { tipo: 'success', message:'el mensaje de success'}
      state.notification = Object.assign({}, payload);
    },
    CLEAR_NOTIFICATION(state, payload) {
      state.notification = { tipo: "", message: "" };
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LAYOUT(state, newLayout) {
      state.layout = newLayout;
    },
    SAVE_NAVIGATION(state, data) {
      state.navigation_options = data;
    }
  },
  actions: {
    // NAVIGATION_OPTIONS({ commit }, data) {
    //   commit("SAVE_NAVIGATION", data);
    // }
  },
  getters: {
    navigationData: state => state.navigation_options,
  }
});
